// extracted by mini-css-extract-plugin
export default {"home":"index_home__vXukK","content":"index_content__ocv6E","top":"index_top__d+b1F","table":"index_table__wYh2F"};